<div class="modal-header">
    <h3 class="modal-title">Error Inesperado
        <span class="text-danger me-2">
            <i class="fa-solid  fa-exclamation" style></i>
        </span>
    </h3>

    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close(false)"></button>
</div>
<div class="modal-body">
    <h4>Ha ocurrido un error inesperado.</h4>
    <p>Contate al administrador del sistema.</p>
    <pre class="text-danger">{{ message()}}</pre>
    @if (stacktrace()){
    <p>
        <a class="btn btn-outline-secondary" data-bs-toggle="collapse" href="#collapseExample" role="button"
            aria-expanded="false" aria-controls="collapseExample">
            Ver Detalle...
        </a>

    </p>
    <div class="collapse" id="collapseExample">
        <div class="card card-body">
            <pre class="text-danger">
            {{ stacktrace()|json }}            
        </pre>
        </div>
    </div>

    <br />

    }
</div>
<div class=" modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(true)">Cerrar</button>
</div>